import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteDockCarrierActions as Actions,
  DeleteDockCarrierRequestAction as RequestAction,
} from 'store/ducks/dockCarriers';

export function* deleteDockCarrierRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `dock-carriers/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Transportadora desvinculada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
